import { DisplayIneligiblePromoModalObservable } from '../../components/ineligiblePromoModal/ineligiblePromoModal';
import { ITransaction, Transaction } from '../../core/domain/module';
import { StateAbbr } from '../../core/enums/stateAbbreviations';
import { StateRestricted } from '../../core/enums/stateRestricted';
import { stateRestrictedAlternativeBundles, stateSpecificRestrictedFunnels } from '../../core/services/bundle/funnelConfigurations';
import { Bundle, Tracking, IBundle } from '../../core/services/module';
import { stateOptions } from '../../stateOptions';

export async function usersCurrentBundleIncompatibleWithState(
	state: StateAbbr,
	tracking = Tracking.Instance(),
	bundleService = Bundle.Instance(),
	transaction = Transaction.Instance()
) {
	const funnelId = await tracking.getFunnelId();
	const stateHasAmmunitionRestrictions = stateOptions
		.filter((s) => s.restrictions?.includes(StateRestricted.AmmunitionShipping))
		.find((s) => s.value.toLowerCase() === state.toLowerCase());

	if (
		stateHasAmmunitionRestrictions &&
		funnelId.wasSuccessful &&
		funnelId.value &&
		stateSpecificRestrictedFunnels[StateRestricted.AmmunitionShipping].includes(funnelId.value)
	) {
		transaction.alternativeBundleId = stateRestrictedAlternativeBundles[funnelId.value];
		const isAlreadyUsingAlternativeBundle = transaction.useDefaultBundle ||
			(transaction.alternativeBundleId && transaction.Data.currentBundle?.id === transaction.alternativeBundleId);
		return isAlreadyUsingAlternativeBundle ? false : await useAlternativeBundle(bundleService, transaction);
	}

	return false;
}

async function useAlternativeBundle(
	bundleService: IBundle,
	transaction: ITransaction
): Promise<boolean> {
	let alternativeBundle = transaction.alternativeBundleId ?
			(await bundleService.getBundleProductsForAllLevels()) :
			(await bundleService.getDefaultBundleProductsForAllLevels());
	if (transaction.alternativeBundleId && (!alternativeBundle.wasSuccessful || !alternativeBundle.value)) {
		transaction.alternativeBundleId = null;
		alternativeBundle = await bundleService.getDefaultBundleProductsForAllLevels();
	}
	if (alternativeBundle.wasSuccessful && alternativeBundle.value) {
		DisplayIneligiblePromoModalObservable.Publish(alternativeBundle.value);
		return true;
	}
	return false;
}
